"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/NotificationPreferenceModal/Form/NotificationSoundSection.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _notifications = require('shared/services/notifications');
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _hooks = require('web/services/hooks');
var _NotificationSoundPicker = require('web/components/NotificationSoundPicker'); var _NotificationSoundPicker2 = _interopRequireDefault(_NotificationSoundPicker);








const NotificationSoundSection = ({ selectedSound, onSubmit }) => {
  const playSound = _hooks.usePlaySoundEffect.call(void 0, )
  const {
    isOpen: isSoundPickerOpen,
    onOpen: onOpenSoundPicker,
    onClose: onCloseSoundPicker,
  } = _useToggle2.default.call(void 0, )

  const onPlayCurrentSound = () => selectedSound && playSound(selectedSound)
  const soundName = _notifications.getSoundName.call(void 0, selectedSound, "Default")

  return (
    _react2.default.createElement('div', { className: "chat--notification-settings--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
      , _react2.default.createElement('span', { className: "chat--notification-settings--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}, "Notification Sound" )
      , _react2.default.createElement('div', { className: "chat--notification-settings--sound-picker", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
        , _react2.default.createElement('div', {
          className: "chat--notification-settings--sound-btn",
          onClick: onPlayCurrentSound, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}

          , _react2.default.createElement('span', { className: "chat--notification-settings--sound-play-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
            , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}, "play_arrow")
          )
          , _react2.default.createElement('span', { className: "chat--notification-settings--sound-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
            ,  soundName 
          )
        )
        , _react2.default.createElement('button', {
          className: "chat--notification-settings--change-sound-btn",
          onClick: onOpenSoundPicker, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
, "Change sound"

        )
      )
      , _react2.default.createElement(_NotificationSoundPicker2.default, {
        isOpen: isSoundPickerOpen,
        onClose: onCloseSoundPicker,
        defaultChosenSound: selectedSound,
        noneLabel: "Default",
        onSubmit: onSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
      )
    )
  )
}

exports. default = NotificationSoundSection
